import styled from "@emotion/styled";
import Link from "../Link";

const NavLink = styled(Link)`
  color: #555555;
  font-family: ROBOTO;
`;

export default NavLink;
